import { setShowSeachActionTypes } from "./actionTypes";

export const setShowSeach = (payload) => {
  return {
    type: setShowSeachActionTypes.SET_SHOW_SEARCH,
    payload,
  };
};
